import React from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const styleAny: any = styles;
const useStyles = makeStyles(styleAny);

// eslint-disable-next-line @typescript-eslint/no-explicit-any

type TSideBar =
  | "dashboard"
  | "suppliers"
  | "suppliersinew"
  | "supplier-profile"
  | "workers"
  | "workers-new"
  | "subcontractors"
  | "documents"
  | "reports"
  | "bulk-upload"
  | "bulk-upload-wip"
  | "analyzes"
  | "my-profile"
  | "my-profile-icon"
  | "edit-profile"
  | "edit-profile-icon"
  | "options"
  | "options-icon"
  | "sows"
  | "sows-new"
  | "sows-admin"
  | "users"
  | "sandbox"
  | "consolidated-workers"
  | "equipments"
  | "activity-item-settings"
  | "external-dashboards";

interface ITitlePagesProps {
  type: "sidebar";
  title: TSideBar;
}

export const TitlePages = ({ type, title }: ITitlePagesProps) => {
  const classes = useStyles();
  const tTitle = useTranslation(type);
  return <h4 className={classes.cardIconTitle}>{tTitle.t(title)}</h4>;
};
